/**
 * 사이트 운영자 정보 — 푸터 사업자 표시, 개인정보 처리방침, 문의 페이지가 공유한다.
 *
 * 전자상거래법상 유료 판매 전에 상호·대표자·사업자등록번호·통신판매업 신고번호·주소·
 * 연락처를 사이트에 표시해야 한다. 값이 빈 문자열인 항목은 화면에 출력하지 않으므로
 * 사업자 등록 후 여기만 채우면 된다.
 */
export const SITE_URL = "https://usedevit.com";

export const SUPPORT_EMAIL = "heerock93@gmail.com";

export const BUSINESS_INFO = {
  /** 상호 */
  companyName: "",
  /** 대표자 */
  representative: "",
  /** 사업자등록번호 (000-00-00000) */
  registrationNumber: "",
  /** 통신판매업 신고번호 */
  mailOrderNumber: "",
  /** 사업장 주소 */
  address: "",
  /** 고객센터 전화 (선택) */
  phone: "",
} as const;

/** 개인정보 보호책임자 — 이름이 비어 있으면 연락처만 표시한다. */
export const PRIVACY_OFFICER = {
  name: "",
  email: SUPPORT_EMAIL,
} as const;
